import { useMatches } from 'react-router';
import { enableNewNavigation } from '@gonfalon/dogfood-flags/dogfood-flags';

import { useIsFlatProjectSettingsSurface } from '../SettingsNavigation/useIsFlatProjectSettingsSurface';

import { flatSettingsBreadcrumbSchema } from './breadcrumbSchemas';

const replacesLeadingCrumbs = (handle: unknown) =>
  flatSettingsBreadcrumbSchema.safeParse(handle).data?.flatSettings.leading !== undefined;

export function useShowsProjectSwitcherCrumb() {
  const matches = useMatches();
  const isFlatProjectSettingsSurface = useIsFlatProjectSettingsSurface();
  return (
    isFlatProjectSettingsSurface &&
    !enableNewNavigation() &&
    !matches.some((match) => replacesLeadingCrumbs(match.handle))
  );
}
